$(document).ready(function () {
    handleClickMessageBox();
    handleClickOutside();
    handleCloseButton();
});

function handleClickMessageBox() {
    $('#message-box').click(function (e) {
        e.stopPropagation();
        toggleChatList();
    });
}

function handleClickOutside() {
    $(document).click(function (e) {
        // Kiểm tra nếu click ra ngoài chat widget
        if (!$(e.target).closest('.chat-widget-box').length) {
            hideChatList();
        }
    });
}

function handleCloseButton() {
    $('#chat-list-close').click(function (e) {
        e.stopPropagation();
        hideChatList();
    });
}

function toggleChatList() {
    const chatList = $('#chat-list');
    if (chatList.hasClass('show')) {
        hideChatList();
    } else {
        showChatList();
    }
}

function showChatList() {
    $('#chat-list').addClass('show');
}

function hideChatList() {
    $('#chat-list').removeClass('show');
}
